import { render, staticRenderFns } from "./AccountHolderBeneficiaries.vue?vue&type=template&id=6e125ab2&scoped=true"
import script from "./AccountHolderBeneficiaries.vue?vue&type=script&lang=ts"
export * from "./AccountHolderBeneficiaries.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderBeneficiaries.vue?vue&type=style&index=0&id=6e125ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e125ab2",
  null
  
)

export default component.exports